import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { TwoColumn } from 'components/layout'

interface DetailsSectionProps {
  user: User
}

const DetailRow: FC<{ label: string; children: ReactNode }> = ({
  label,
  children,
}) => (
  <div className="flex flex-col gap-1">
    <span className="text-xs font-medium uppercase text-neutral-600">
      {label}
    </span>
    <span className="text-sm text-neutral-900">{children}</span>
  </div>
)

export const DetailsSection: FC<DetailsSectionProps> = ({ user }) => {
  const { t } = useTranslation()

  return (
    <TwoColumn
      label={t('features.usersAdmin.userDetails.details')}
      description={t('features.usersAdmin.userDetails.detailsDescription')}
    >
      <div className="flex flex-col gap-5 w-[825px]">
        <DetailRow label={t('features.usersAdmin.email')}>
          {user.email}
        </DetailRow>
        <DetailRow label={t('common.facility')}>
          {user.latestFacility?.name ?? t('common.notAvailable')}
        </DetailRow>
      </div>
    </TwoColumn>
  )
}
